module.exports = __webpack_public_path__ + "static/media/6.46a29257.jpg";